import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { UpdateOperation } from '../types';
import type { PaginatedResponse } from '@shared/types';

export function useOperations() {
  return useQuery({
    queryKey: queryKeys.updates.operations,
    queryFn: () => apiClient.get<PaginatedResponse<UpdateOperation>>('/updates/operations'),
  });
}
